import { useMemo } from 'react'

import AppStore from '@v4/store/appStore'
import { getOverallScore, getTier } from '@v4/utils'
import { useScoreFormat } from '@v4/hooks/index'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import { useSectionId } from '@v4/components/common/SectionItem'
import ScoreTiersSelector from '@v4/utils/selectors/ScoreTiersSelector'

export default ({ useCustomScoreColor, group, scoreTextPrimary, scoreFormat }) => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const tiers = ScoreTiersSelector.useData()
	const result = AppStore.useStoreState(state => state.result.data)
	const sectionId = useSectionId()
	const activeTierId = PageBuilderSelector.useMetaItemActiveTierId({ sectionId, group })

	const { score_percent: percent, score } = useMemo(() => {
		return getOverallScore(result.scores)
	}, [result.scores])

	const { score_colour: color, name: tierName, score_from: min, score_to: max, id } = useMemo(() => {
		return getTier(tiers, percent, activeTierId) || {}
	}, [activeTierId, percent, tiers])

	const customColor = useCustomScoreColor && scoreTextPrimary
	const scoreColor = customColor || color
	const isActiveBuilderMode = Boolean(isBuilderMode && activeTierId)
	const averageScore = (min + max) / 2
	const tierPercent = Math.round(averageScore) / 100
	const currentPercent = isActiveBuilderMode ? tierPercent : percent
	const totalScore = useScoreFormat(scoreFormat, currentPercent, score, {
		withDenominator: true,
	})

	return {
		scoreColor,
		totalScore,
		tierName,
		tiers,
		percent: currentPercent,
		activeTierId: id,
	}
}
